export function formatString(str: any): string {
  if (!str) return '';
  const s = String(str).replace(/_/g, ' ').trim().replace(/\s+/g, ' ');
  return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}
